enum BindStateEnum {
    INIT = 0,
    BINDING_IN_PROGRESS = 1,
    BINDING_SUCCESS = 2,
    BINDING_ERROR = 3,
    RELEASE = 4,
}

export default BindStateEnum
